export default __webpack_public_path__ + "media/images/svg/icon_logo_blue-ce1129599621e7388c3e545cc74cbd50.svg";